module.exports = "/static/js/bd1e90af74eb0659eacb415c376f9e7d.png";